import React, { useState, useEffect, createRef, forwardRef } from "react";
import Doughnut from "./Doughnut";
import Spinner from "../../../components/Spinner";
import { getCurrentSummaryData, getSummaryKpiSelected, getTableLoading } from "../../../selectors";
import { connect } from "react-redux";
import { Col, Row, Tabs, Dropdown, Menu, Icon } from "antd";
import { TYPE_SORT, SOURCE, SOURCES_LIST } from "./constants";
import moment from "moment";
import FileSaver from "file-saver";

const TITLE_HEIGHT = 100;
const HEIGHT_ELEMENT = 160;
const WIDTH_ELEMENT = 500;
const DOUGHNUT_SIZE = 100;
const KpiViewList = props => {
  const data = props.data || [];
  const kpi = props.kpi || {};
  const rows = [];
  for (let i = 0; i < data.length; i += 2) {
    const cols = [];
    for (let j = i; j < i + 2; j++) {
      const item = data[j];
      if (!item) continue;
      cols.push(
        <Col xs={12} xl={6} style={{ marginBottom: 10 /*marginTop: j % 2 !== 0 ? 0 : 0*/ }}>
          <div
            className="p-w-1-2 p-txt-center"
            style={{
              fontSize: "15px",
              height: 60,
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <span>{item.elementName}</span>
          </div>
        </Col>
      );
      cols.push(
        <Col xs={12} lg={6} style={{ marginBottom: 10 /*marginTop: j % 2 !== 0 ? 0 : 0*/ }}>
          <Doughnut
            _id={`${props._id}-${j}`}
            newestPercentage={item.newestPercentage}
            oldestPercentage={item.oldestPercentage}
            kpi={kpi}
            size="small"
            style={{ height: 60, width: 60 }}
          />
        </Col>
      );
    }
    rows.push(<Row gutter={[16, 16]}>{cols}</Row>);
  }
  return rows;
};
const processData = (data, source, typeSort) => {
  const subData = data[source] || {};

  const dataByBrand = subData.data || [];
  dataByBrand.sort((a, b) => {
    if (typeSort === TYPE_SORT.ALPHABETICALLY) {
      if (a.dim_value > b.dim_value) return 1;
      else return -1;
    } else if (typeSort === TYPE_SORT.INCREASING) {
      if (a.value > b.value) return 1;
      else return -1;
    } else {
      if (a.value < b.value) return 1;
      else return -1;
    }
  });
  const dataMulti = dataByBrand.map(v => {
    return {
      elementName: v.dim_value,
      newestPercentage: v.value,
      oldestPercentage: 0
    };
  });
  return dataMulti;
};

const getImage = idImage => {
  const svg = document.querySelector(idImage);
  let img = new Image();
  const xml = new XMLSerializer().serializeToString(svg);
  const svg64 = btoa(xml);
  const b64Start = "data:image/svg+xml;base64,";
  const image64 = b64Start + svg64;
  img.src = image64;
  return img;
};
const MultiGlobalKpiView = ({ kpi = {}, data = {}, loading, period }) => {
  const [source, setSource] = useState(SOURCE.BRAND);
  const [typeSort, setTypeSort] = useState(TYPE_SORT.ALPHABETICALLY);
  const [dataMulti, setDataMulti] = useState(processData(data, source, typeSort));

  useEffect(() => {
    setDataMulti(processData(data, source, typeSort));
  }, [data, source, typeSort]);

  function callback(key) {
    setSource(key);
  }
  const keysList = SOURCES_LIST.filter(item => Object.keys(data).findIndex(dataSource => dataSource === item.key) > -1);

  return (
    <div>
      <div style={{ display: "flex" }}>
        <Dropdown
          overlay={
            <Menu
              style={{ width: 200 }}
              onClick={({ key }) => {
                setTypeSort(key);
              }}
            >
              {TYPE_SORT.INCREASING !== typeSort && (
                <Menu.Item key={TYPE_SORT.INCREASING}>Trier par ordre croissant</Menu.Item>
              )}
              {TYPE_SORT.DECREASING !== typeSort && (
                <Menu.Item key={TYPE_SORT.DECREASING}>Trier par ordre décroissant</Menu.Item>
              )}
              {TYPE_SORT.ALPHABETICALLY !== typeSort && (
                <Menu.Item key={TYPE_SORT.ALPHABETICALLY}>Trier par ordre alphabétique</Menu.Item>
              )}
            </Menu>
          }
        >
          <div>
            <Icon type="bar-chart" style={{ marginLeft: 10 }} />
          </div>
        </Dropdown>
        <div
          onClick={() => {
            const key_index = keysList.findIndex(key => source === key.key);

            const canvas = document.querySelector("#canvas");
            canvas.width = WIDTH_ELEMENT * 2;
            canvas.height = (HEIGHT_ELEMENT * dataMulti.length) / 2 + TITLE_HEIGHT + 20;
            const ctx = canvas.getContext("2d");
            ctx.fillStyle = "#FFFFFF";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.fillStyle = "#000000";
            ctx.font = "bold 26px Arial";
            ctx.textAlign = "center";
            ctx.fillText(
              `${kpi.long_label} ${keysList[key_index].title} du ${moment(period[0]).format("DD-MM-YYYY")} au ${moment(
                period[1]
              ).format("DD-MM-YYYY")}`,
              WIDTH_ELEMENT,
              TITLE_HEIGHT / 2
            );
            ctx.translate(0, TITLE_HEIGHT);
            dataMulti.map((brand, i) => {
              ctx.textAlign = "center";
              ctx.font = "normal 22px Arial";
              ctx.fillText(
                `${brand.elementName}`,
                (i % 2) * WIDTH_ELEMENT + 170,
                Math.floor(i / 2) * HEIGHT_ELEMENT + 58
              );
              ctx.fillText(
                `${(Math.round(brand.newestPercentage * 10) / 10).toFixed(1)} %`,
                (i % 2) * WIDTH_ELEMENT + DOUGHNUT_SIZE / 2 + 340,
                Math.floor(i / 2) * HEIGHT_ELEMENT + 56
              );
              ctx.beginPath();
              ctx.lineWidth = 4;
              ctx.strokeStyle = "#D6D6D6";
              ctx.arc(
                (i % 2) * WIDTH_ELEMENT + DOUGHNUT_SIZE / 2 + 340,
                Math.floor(i / 2) * HEIGHT_ELEMENT + 50,
                44,
                0,
                2 * Math.PI,
                false
              );

              ctx.stroke();
              ctx.beginPath();
              ctx.strokeStyle = "#DB1E09";
              ctx.arc(
                (i % 2) * WIDTH_ELEMENT + DOUGHNUT_SIZE / 2 + 340,
                Math.floor(i / 2) * HEIGHT_ELEMENT + 50,
                44,
                (3 * Math.PI) / 2,
                (3 * Math.PI) / 2 + (2 * Math.PI * brand.newestPercentage) / 100,
                false
              );

              ctx.stroke();
            });
            FileSaver.saveAs(
              canvas.toDataURL(),
              `${kpi.long_label}_${keysList[key_index].title}_du_${moment(period[0]).format("DD-MM-YYYY")}_au_${moment(
                period[1]
              ).format("DD-MM-YYYY")}_doughnut.png`
            );
          }}
          style={{ cursor: "pointer", marginLeft: 10 }}
        >
          <Icon type="camera"></Icon>
        </div>
      </div>

      <canvas style={{ display: "none" }} id="canvas"></canvas>
      <Tabs defaultActiveKey={SOURCE.BRAND} id="doughnut" size="small" onChange={callback} style={{ width: "100%" }}>
        {keysList.map((key, i) => (
          <Tabs.TabPane tab={<h2 className="p-page-subtitle p-txt-center">{key.title}</h2>} key={key.key}>
            <div className="p-al-c-center" style={{ position: "relative", marginTop: 20 }} id="doughnut">
              {loading ? <Spinner style={{ top: 100 }} /> : null}
              {/* {props.title} */}
              {!loading && <KpiViewList _id={`circular-${i}`} kpi={kpi} data={dataMulti} />}
            </div>
          </Tabs.TabPane>
        ))}
      </Tabs>
    </div>
  );
};
const mapStateToProps = (state, ownProps) => {
  return {
    period: state.stats.period,
    data: getCurrentSummaryData(state),
    loading: getTableLoading(state),
    kpi: getSummaryKpiSelected(state)
  };
};
export default connect(mapStateToProps, null)(MultiGlobalKpiView);



// WEBPACK FOOTER //
// src/modules/stats/containers/summary/Global/MultiGlobalKpiView.js